import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import PropTypes from 'prop-types';

import RouteService from '../../../services/RouteService';
import HelperNavigation from '../../common/HelperNavigation';
import globalTranslations from '../../../i18n/globalTranslations';
import Paths from '../../../types/Paths';
import MyAccountInfoForm from '../MyAccountInfoForm';
import PageTitle from '../../common/PageTitle';
import SEOTitle from '../../head/SEOTitle';
import AccountStore from '../../../store/AccountStore';
import { modelOf } from '../../../prop-types';

@observer
export class MyAccountInfo extends Component {
  getBreadcrumbsPath = () => {
    const { accountStore, intl, routeService } = this.props;
    return routeService.transformBreadCrumbs([
      {
        text: intl.formatMessage(globalTranslations.myAccount),
        url: accountStore.isBalanceBuyer
          ? Paths.MyAccountBalanceUser
          : Paths.MyAccount
      },
      {
        text: accountStore.isBalanceBuyer
          ? intl.formatMessage(globalTranslations.balanceUserAccountInfo)
          : intl.formatMessage(globalTranslations.myAccountInfo),
        url: accountStore.isBalanceBuyer
          ? Paths.MyAccountBalanceUserAccountInfo
          : Paths.MyAccountInfo
      }
    ]);
  };

  render() {
    const { accountStore } = this.props;
    const title = accountStore.isBalanceBuyer
      ? globalTranslations.balanceUserAccountInfo
      : globalTranslations.myAccountInfo;
    return (
      <Fragment>
        <HelperNavigation breadcrumbsPath={this.getBreadcrumbsPath()} />
        <div className="MyAccountInfo">
          <SEOTitle
            title={
              accountStore.isBalanceBuyer
                ? globalTranslations.balanceUserAccountInfo
                : globalTranslations.myAccountInfo
            }
          />
          <PageTitle>
            <FormattedMessage {...title} />
          </PageTitle>
          <MyAccountInfoForm />
        </div>
      </Fragment>
    );
  }
}

MyAccountInfo.propTypes = {
  accountStore: modelOf(AccountStore).isRequired,
  intl: intlShape.isRequired,
  routeService: PropTypes.instanceOf(RouteService).isRequired
};

export default injectIntl(
  inject('accountStore', 'routeService')(MyAccountInfo)
);



// WEBPACK FOOTER //
// ./src/components/my-account/MyAccountInfo/index.jsx